@if (showNotification) {
  <div  [class]="notification.type">
    <p [innerHTML]="notification.html" class="m-m"></p>
  </div>
}
<h2>Benutzer Bearbeiten</h2>
<div class="d-flex">
  <form [formGroup]="userForm" class="w-50">
    <input type="hidden" formControlName="id" />
    <mat-form-field appearance="outline">
      <mat-label>Anrede</mat-label>
      <mat-select formControlName="salutation">
        @for (salutation of this.getSalutationValues(); track salutation) {
          <mat-option [value]="salutation">
            {{ salutation }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Titel</mat-label>
      <input matInput formControlName="title"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Vorname</mat-label>
      <input matInput formControlName="first_name"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="last_name"/>
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>E-mail</mat-label>
      <input matInput formControlName="email"/>
    </mat-form-field>
    @if (editUsername) {
      <mat-form-field appearance="outline">
        <mat-label>Benutzername</mat-label>
        <input matInput formControlName="username"/>
      </mat-form-field>
    }
    <mat-form-field appearance="outline">
      <mat-label>Benutzergruppe</mat-label>
      <mat-select formControlName="group">
        @for (group of userGroups | keyvalue; track group) {
          <mat-option [value]="group.key">
            {{ group.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <br>
      <button mat-flat-button color="primary" (click)="submit()">Speichern</button>
    </form>
    @if (this.user.username) {
      <div class="w-50 d-flex jcsb">
        <div>
          <p>Status: {{ getStatus(user.user.status) }}</p>
          <div>Username: {{user.username}} <button mat-icon-button color="accent" (click)="editUsername=!editUsername"><mat-icon fontSet="material-symbols-outlined">create</mat-icon></button></div>
          <p>E-mail: {{ user.email }}</p>
        </div>
      </div>
    }
  </div>
